import { Suspense } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import { HeroSection } from "@/components/sections/HeroSection";
import { SEOHead } from "@/components/SEOHead";
import { getHomepageJsonLd, getSEOContent } from "@/lib/seoData";
import { useLanguage } from "@/contexts/LanguageContext";

// Lazy load below-fold sections to reduce TBT and improve FCP
const UnifiedServicesSection = lazyWithRetry(() => import("@/components/sections/UnifiedServicesSection").then(m => ({ default: m.UnifiedServicesSection })));
const HowItWorksSection = lazyWithRetry(() => import("@/components/sections/HowItWorksSection").then(m => ({ default: m.HowItWorksSection })));
const WhoItIsForTeaser = lazyWithRetry(() => import("@/components/sections/WhoItIsForTeaser").then(m => ({ default: m.WhoItIsForTeaser })));
const TestimonialsSection = lazyWithRetry(() => import("@/components/sections/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));
const CTASection = lazyWithRetry(() => import("@/components/sections/CTASection").then(m => ({ default: m.CTASection })));


const Index = () => {
  const { language } = useLanguage();
  const seo = getSEOContent("home", language);
  return (
    <>
      <SEOHead
        title={seo.title}
        description={seo.description}
        routeKey="home"
        jsonLd={getHomepageJsonLd(language)}
      />
      <HeroSection />
      <Suspense
        fallback={
          <div
            aria-hidden="true"
            style={{ minHeight: "80vh", background: "hsl(var(--background))" }}
          />
        }
      >
        <UnifiedServicesSection />
        <WhoItIsForTeaser />
        <HowItWorksSection />
        <TestimonialsSection />
        <CTASection />
      </Suspense>
    </>
  );
};

export default Index;
